import { FigureInteractionEventDispatch } from './Contexts';
import { useContext } from 'react';
export default function useEditorDispatch(){

  const onFigureInteractionEvent = useContext(FigureInteractionEventDispatch);

  return onFigureInteractionEvent;


}
